import { useTranslation } from "@sagot/i18n";
import { Icon, cn } from "@sagot/ui";
import { PASSWORD_RULE_KEYS, type PasswordRules } from "../../lib/password";

const RULE_LABEL = { len: "ruleLen", case: "ruleCase", num: "ruleNum", sym: "ruleSym", match: "ruleMatch" } as const;

/** `[data-pw-rules]`: live checklist (state as icon + text + colour). */
export function PasswordRulesList({ rules }: { rules: PasswordRules }) {
  const { t } = useTranslation();
  return (
    <ul aria-label={t("auth.password.rulesLabel")} className="grid grid-cols-1 gap-1.5 rounded-lg border border-line bg-surface p-3.5 text-[13px] sm:grid-cols-2">
      {PASSWORD_RULE_KEYS.map((key) => {
        const ok = rules[key];
        return (
          <li key={key} className={cn("flex items-center gap-2 transition-colors", ok ? "text-success" : "text-fg-muted", key === "match" && "sm:col-span-2")}>
            <Icon name={ok ? "check-circle" : "circle"} className="size-4" />
            {t(`auth.password.${RULE_LABEL[key]}`)}
            <span className="sr-only">({ok ? t("auth.password.ruleMet") : t("auth.password.ruleNotMet")})</span>
          </li>
        );
      })}
    </ul>
  );
}
